export const config = {
  apiBase: "https://app.nthecloud.com/api"
};
